import { HoverInfoTooltip } from 'pages/Admin/AuctionDetail/components/HoverInfo';
import { useCustomerHoverStateHandlers } from 'pages/Admin/AuctionDetail/hooks';
import { useRef } from 'react';
import styled from 'styled-components';
import { User } from 'types/user';

type Props = {
  statusColor?: string;
  user: User;
};

const InnerText = styled.div`
  color: ${props => props.color};
  cursor: pointer;
`;

export const UserWithTooltip = ({ user, statusColor = '#000' }: Props) => {
  const { isOpen, handleClose, handleOpen } = useCustomerHoverStateHandlers();

  const ref = useRef(null);

  return (
    <HoverInfoTooltip
      anchorEl={ref.current}
      initialPage={'/admin/vehicles'}
      userId={user.id}
      isPopoverOpened={isOpen}
      closeTooltip={handleClose}
      tooltipName={user.dealership_name}
      maxWidth={Number.MAX_SAFE_INTEGER}
    >
      <div onClick={handleOpen}>
        <InnerText ref={ref} color={statusColor}>
          {user.dealership_name}
        </InnerText>
      </div>
    </HoverInfoTooltip>
  );
};

export const SellerWithTooltip = ({ user }: { user: User }) => {
  const seller = user.seller;
  const sellerHasOnlyAchFlooring =
    seller &&
    seller.purchase_options &&
    seller.purchase_options.find(({ option_name }) => option_name === 'ach_flooring') &&
    seller.purchase_options.length === 1;

  return <UserWithTooltip user={user} statusColor={sellerHasOnlyAchFlooring ? '#009F0F' : 'black'} />;
};
